export const categories = [
  "Topwear",
  "Bottomwear",
  "Outerwear",
  "Footwear",
  "Accessories",
  "Bags",
  "Sale",
];
